var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header-box"},[_c('span',{staticClass:"title-text"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"header-extra"},[_vm._t("extra")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }